<mat-chip class="mat-pill" [disableRipple]="true" [ngClass]="class()" [disabled]="disabled()">{{ text() }}</mat-chip>
